import { motion } from "framer-motion";
import { SubMotionProps } from '../../types';

export default function ContentMotion({ children, style }: SubMotionProps) {
    return (
        <motion.div
            variants={{
                initial: { opacity: 0.75, x: "-5px" },
                final: { opacity: 1, x: "0px", transition: { duration: 0.4, delay: 0.25 } },
            }}
            initial="initial"
            animate="final"
            style={style}
        >
            {children}
        </motion.div>
    )
}